import type { FaireProductEntity } from "../../entity_types/product";

export const p_b4rm54a264: FaireProductEntity = {
  token: "p_b4rm54a264",
  type: "product",
  name: "Dancing Skellies Sweatshirt",
  brandToken: "b_tacvsj4rz9",
  brandName: "Unknown Brand",
  imageUrl:
    "https://cdn.faire.com/fastly/2aa86b69796d2ccc42fec9fbd4426ad3c969ee9dd9f07d2cff5a57a0282b6933.jpeg",
  galleryImageUrls: [
    "https://cdn.faire.com/fastly/68134c4ae95a100374f4c9faa00b36213cf97719b186f47b27ce5054ac425c52.jpeg",
    "https://cdn.faire.com/fastly/34a6cd15f67bc0d84ed943d3ce0b79f01b8d3af7c894b82768509c3f7f8da8db.png",
  ],
  priceDollars: 40.19,
  description:
    "Skellies will be dancing all year long with these hand bleached, cozy crewnecks! Sweatshirts are a very soft and comfy unisex fit, each one unique in its own way down to the bleach effects. ",
  tags: [],
  msrpDollars: 80.37,
  inStock: true,
  meta: {
    source: "api",
    importedAt: "2026-03-26T22:25:12.743Z",
    importedBy: "entity-db-cli",
  },
  categoryTokens: [],
};
